// extracted by mini-css-extract-plugin
export default {"rating":"lz-z","numberOfStars":"mz-z","count":"nz-z","barGraphSpacing":"oz-z","barGraph":"pz-z"};